<script setup>
import NewsPageRubricsSwitcher from "@/components/NewsPage/NewsPageRoof/NewsPageRubricsSwitcher.vue";
import NewsPageThemesSwitcher from "@/components/NewsPage/NewsPageRoof/NewsPageThemesSwitcher.vue";
import NewsPageSearchBar from "@/components/NewsPage/NewsPageRoof/NewsPageSearchBar.vue";
import NewsPageFavorite from "@/components/NewsPage/NewsPageRoof/NewsPageFavorite.vue";
import {defineProps, onBeforeUnmount, onMounted, ref, defineEmits} from "vue";

const newsPageRoofWidth = ref(window.innerWidth);

defineProps({
  isToolbarActive: {
    type: Boolean,
    required: true,
    default: false
  }
});

const emit = defineEmits(["update:is-toolbar-active"]);

onMounted(() => {
  window.addEventListener("resize", handleWindowResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleWindowResize);
});

const handleWindowResize = () => {
  newsPageRoofWidth.value = window.innerWidth;
};

</script>
<template>
  <div
    ref="newsPageRoofRef"
    class="news-roof"
  >
    <NewsPageThemesSwitcher :news-page-roof-width="newsPageRoofWidth" />
    <NewsPageRubricsSwitcher :news-page-roof-width="newsPageRoofWidth" />
    <NewsPageSearchBar :news-page-roof-width="newsPageRoofWidth" />
    <NewsPageFavorite
      @update:is-toolbar-active="val => emit('update:is-toolbar-active', val)"
    />
  </div>
</template>
<style lang="scss" scoped>
.news-roof {
  display: flex;
  gap: 10px;
  width: 100%;
}
</style>
